import HCaptcha from "@hcaptcha/react-hcaptcha";
import Footer from "components/layout/footer";
import Loader from "components/loader";
import SEO from "components/seo";
import { Link } from "gatsby";
import { useFetchComments } from "hooks/Comments/useFetchComments";
import { usePostComments } from "hooks/Comments/usePostComments";
import moment from "moment";
import React, { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import TranslatorHubHeader from "../../TranslatorHub/TranslatorHubHeader/TranslatorHubHeader";
import Form from "../Form";
import Social from "../Social";


const Index = (props) => {
  const [value, setValue] = useState(false);
  const [token, setToken] = useState(false);
  const [formStatus, setForStatus] = useState(false);
  const captchaRef = useRef(null);
  const {
    pageContext: {
      data: { data },
    },
  } = props;

  const project_id = data.seo_project_id;

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const { data: dataOne, isFetching, fetchNextPage, hasNextPage } = useFetchComments(project_id);
  const { status, mutateAsync } = usePostComments();

  const onSubmit = (data) => {
    if (token) {
      const postData = {
        name: data.name,
        email: data.email,
        content: data.content,
        seo_project_id: project_id,
        notification: value,
      };
      mutateAsync(postData).then((_) => {
        reset();
        setForStatus(true);
      });
    } else {
      alert("Please verify captcha");
    }
  };

  const handleChange = (e) => {
    const { checked } = e.target;
    setValue(checked);
  };

  const handleVerify = () => {
    setToken(true);
  };

  return (
    <React.Fragment>
      <TranslatorHubHeader title={"Business Translation Center"} />
      <SEO
        title={data.seo_project_title || data.title_x || data.seo_h1}
        description={data.seo_project_meta_desc}
        keywords={data.seo_project_meta_keywords}
        slug={data.slug}
      />
        <div className="flex flex-col lg:flex-row w-11/12 sm:w-10/12 md:w-11/12 md:px-3 md:max-w-2xl lg:max-w-none xl:max-w-7xl  mx-auto lg:w-full xl:pl-[150px] lg:gap-20">
          <div className="col-span-2">
            <h1 className="text-[28px] pb-6 text-blackNew-600 font-semibold mt-10">
              {data.seo_h1}
            </h1>

            <div className="my-6">
              {data.slug !== "/business-center/press-seo-translation" && <>
              <span className="text-blackNew-700">by</span>{" "}
              <Link
                to="https://www.linkedin.com/in/ofertirosh/"
                target="_blank"
              >
                <span className="text-lightBlue font-bold">OFER TIROSH</span>
                
              </Link>{" "}
              </>}
              <i className="text-blackNew-700">
                {data.seo_project_publish_date ? moment(data.seo_project_publish_date).format("DD/MM/YYYY"):moment(data.seo_project_create_date).format("DD/MM/YYYY")}
              </i>
            </div>
            <img
              src={data.cover_image}
              alt=""
              className="w-full xl:w-full  object-cover h-auto lg:h-[370px] max-h-80 mb-6"
            />
            <div
              className="mb-4 translator_hub_details"
              dangerouslySetInnerHTML={{ __html: data.seo_project_content }}
            />
            <div className="flex items-center justify-items-center flex-col border-t-2 border-blackNew-800 mt-6 py-4">
              <div className="text-left w-full text-[22px] font-medium">
                <i className="text-orange">YOU MAY </i>
                <i className="text-blackNew-700">ALSO LIKE</i>
              </div>
              <div className="flex flex-col sm:flex-row sm:w-10/12 mr-auto gap-x-8">
                {data?.you_may_also_like.map((node, index) => (
                  <div className="mt-5" key={index}>
                    <img
                      src={node.cover_image}
                      // className="w-full"
                      className="min-w-[315px] min-h-[196px]  object-cover mb-6"

                      alt={node.alt}
                    />
                    <Link to={node.slug}>
                      <i className="text-blackNew-900 w-full">{node.title}</i>
                    </Link>
                  </div>
                ))}
              </div>
            </div>

            <div className="commentBar pt-4 border-t-2 border-blackNew-800 mt-4">
              <h4 className="font-semibold text-xl">
                <span className="text-orange">Post</span> your Comment
              </h4>
              {dataOne?.pages.map((page) =>
                page.data.map((c, i) => (
                  <div className="comments pt-6" key={i}>
                    <div className="commentBox max-w-max bg-[#f2f3f5] rounded-lg p-3">
                      <h2 className="font-medium text-lg capitalize">
                        <span>{c?.name}</span>
                      </h2>
                      <p>
                        <span>{c?.content}</span>
                      </p>
                      <span className="text-ligtBlue" style={{ color: "#3a7aff" }}>
                        {c?.created_date}
                      </span>
                    </div>
                  </div>
                ))
              )}
               {hasNextPage && (
                <div className="loadMoreBtn pt-6">
                  <button onClick={fetchNextPage} className="border rounded-lg px-3 py-2 text-white text-sm bg-[#5bc0de] cursor-pointer">
                    {isFetching ? <Loader /> : "Load more"}
                  </button>
                </div>
              )}
            </div>

            <div className="formInfo py-6">
              {formStatus ? (
                <span className="text-[#5C90F7]">
                  <i>
                    Thank you! Your comment will be published as soon as
                    possible.
                  </i>
                </span>
              ) : (
                <></>
              )}
              <form className="flex flex-col" onSubmit={handleSubmit(onSubmit)}>
                <input
                  type="text"
                  className="border border-gray rounded-md p-1 pl-4 "
                  style={{ borderColor: errors.name ? "#DD5451" : "" }}
                  placeholder="Name"
                  name="name"
                  autoComplete="off"
                  {...register("name", { required: true })}
                />

                <input
                  type="text"
                  className="border border-gray rounded-md p-1 pl-4 my-4"
                  placeholder="Email (never display)"
                  name="email"
                  style={{ borderColor: errors.email ? "#DD5451" : "" }}
                  autoComplete="off"
                  {...register("email", {
                    required: true,
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                      message: "Enter a valid e-mail address",
                    },
                  })}
                />
                <textarea
                  cols="30"
                  rows="10"
                  className="border border-gray pl-4"
                  placeholder="Comment"
                  style={{ borderColor: errors.content ? "#DD5451" : "" }}
                  name="content"
                  {...register("content", { required: true })}
                ></textarea>
                <div className="notification flex my-4 items-center gap-x-4">
                  <input
                    type="checkbox"
                    onChange={(e) => handleChange(e)}
                    defaultChecked={value}
                  />
                  <p>
                    I want to receive a notification of new postings under this
                    topic
                  </p>
                </div>
                <HCaptcha
                  sitekey="b6b06718-08ae-457f-a6d7-147046b4c216"
                  onVerify={handleVerify}
                  ref={captchaRef}
                />
                <button
                  type="submit"
                  className="border rounded cursor-pointer border-black bg-black p-2.5 px-6 mt-10 text-white text-sm w-24"
                >
                  {status === "loading" ? <Loader /> : "SUBMIT"}
                </button>
              </form>
            </div>
          </div>
          <div className="w-full ml-0 mt-10 md:mt-0 px-4 lg:pl-0">
            <div>
              <h5 className="font-bold text-newGray text-new mt-4 lg:mt-10">
                CATEGORIES
              </h5>
              <ul className="text-newGray">
                {props.pageContext.uniqueCategories.map((link, index) => (
                  <li
                    className="text-new py-2  hover:text-newLightBlue cursor-pointer"
                    key={index}
                  >
                    <Link to={`/business-center.php/category/${link}`}>{link}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="line border-b border-gray mt-12"></div>
            <Form />
            <Social />
          </div>
        </div>
      
      <Footer />
    </React.Fragment>
  );
};
export default Index;
